exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._8TbTA{margin-top:18px}._2pU0z{background-image:url(\"/img/sample_bg.jpg\");display:-ms-flexbox;min-height:100vh;height:100%;background-size:contain;display:flex;-ms-flex-pack:center;justify-content:center}._2dedh{text-align:center;margin-top:40px}._2Y0OT{font-size:77px;font-style:italic;font-weight:700;margin-bottom:30px}._2cDkS{font-size:18px;margin-bottom:45px}._2cDkS a{cursor:pointer}._2NgOK{height:300px}@media only screen and (max-width:767px){._2pU0z{display:block;background-position-y:12rem;background-repeat:no-repeat}}", ""]);

// exports
exports.locals = {
	"headerPrimary": "_8TbTA",
	"backgroundImg": "_2pU0z",
	"contentDiv": "_2dedh",
	"titleOfError": "_2Y0OT",
	"messageOfError": "_2cDkS",
	"contentErrorImage": "_2NgOK"
};